module.exports = __webpack_public_path__ + "static/media/part-16.b71bd98a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/part-16.jpg
// module id = 949
// module chunks = 0